import { gql } from '@apollo/client'
import { RISK_TEMPLATE_FRAGMENT } from 'graphql/risk/queries'

export const RISK_TEMPLATE_CREATE_MUTATION = gql`
  mutation RISK_TEMPLATE_CREATE_MUTATION($input: RiskTemplateCreateInput!) {
    riskTemplateCreate(input: $input) {
      data {
        id
      }
    }
  }
`

export const RISK_TEMPLATE_UPDATE_MUTATION = gql`
  mutation RISK_TEMPLATE_UPDATE_MUTATION($id: ID!, $input: RiskTemplateUpdateInput!) {
    riskTemplateUpdate(id: $id, input: $input) {
      ok
    }
  }
`

export const RISK_VIEW_CREATE_MUTATION = gql`
  mutation RISK_VIEW_CREATE_MUTATION($input: RiskViewCreateInput!) {
    riskViewCreate(input: $input) {
      data {
        id
        createdAt
        updatedAt
        name
        riskTemplate {
          ...RISK_TEMPLATE
        }
        settings {
          fields {
            fieldId
            active
            fieldLinkId
            parentFieldId
            riskTemplateId
          }
        }
        availableToUserOrPositionIds
      }
    }
  }
  ${RISK_TEMPLATE_FRAGMENT}
`

export const RISK_VIEW_UPDATE_MUTATION = gql`
  mutation RISK_VIEW_UPDATE_MUTATION($id: ID!, $input: RiskViewUpdateInput!) {
    riskViewUpdate(id: $id, input: $input) {
      ok
    }
  }
`

export const RISK_VIEW_DELETE_MUTATION = gql`
  mutation RISK_VIEW_DELETE_MUTATION($id: ID!) {
    riskViewDelete(id: $id) {
      ok
    }
  }
`

export const RISK_CREATE_MUTATION = gql`
  mutation RISK_CREATE_MUTATION($input: RiskCreateInput!) {
    riskCreate(input: $input) {
      data {
        id
        fieldValueMap {
          fieldId
          fieldLinkId
          fieldValue
          fieldValueId
          parentFieldValueId
        }
      }
    }
  }
`

export const RISK_CREATE_PUBLIC_MUTATION = gql`
  mutation RISK_CREATE_PUBLIC_MUTATION($domain: String!, $input: RiskCreateInput!) {
    riskCreatePublic(domain: $domain, input: $input) {
      data {
        id
      }
    }
  }
`

export const RISK_UPDATE_MUTATION = gql`
  mutation RISK_UPDATE_MUTATION($id: ID!, $input: RiskUpdateInput!) {
    riskUpdate(id: $id, input: $input) {
      data {
        id
      }
    }
  }
`

export const RISK_DELETE_MUTATION = gql`
  mutation RISK_DELETE_MUTATION($id: ID!) {
    riskDelete(id: $id) {
      ok
    }
  }
`

export const RISK_CLONE_MUTATION = gql`
  mutation RISK_CLONE_MUTATION($id: ID!, $input: RiskCloneInput) {
    riskClone(id: $id, input: $input) {
      data {
        id
        fieldValueMap {
          fieldId
          fieldLinkId
          fieldValue
          fieldValueId
          parentFieldValueId
        }
      }
    }
  }
`

export const RISK_TEMPLATE_DELETE_MUTATION = gql`
  mutation RISK_TEMPLATE_DELETE_MUTATION($id: ID!) {
    riskTemplateDelete(id: $id) {
      ok
    }
  }
`

export const RISK_VIEW_FILTER_ADD_MUTATION = gql`
  mutation RISK_VIEW_FILTER_ADD_MUTATION($input: FilterCreateInput!) {
    filterCreate(input: $input) {
      id
      createdAt
      createdById
      name
      args
      targetId
    }
  }
`

export const RISK_VIEW_FILTER_UPDATE_MUTATION = gql`
  mutation RISK_VIEW_FILTER_UPDATE_MUTATION($input: FilterUpdateInput!) {
    filterUpdate(input: $input) {
      id
    }
  }
`

export const RISK_VIEW_FILTER_DELETE_MUTATION = gql`
  mutation RISK_VIEW_FILTER_DELETE_MUTATION($input: FilterDeleteInput!) {
    filterDelete(input: $input) {
      ok
    }
  }
`

export const RISK_CONFIRM_PUBLIC_MUTATION = gql`
  mutation RISK_CONFIRM_PUBLIC_MUTATION($domain: String!, $id: ID!) {
    riskRemoveGuestAccessPublic(domain: $domain, id: $id) {
      ok
    }
  }
`

export const EXEC_CUSTOM_FUNCTION_MUTATION = gql`
  mutation EXEC_CUSTOM_FUNCTION_MUTATION($input: ExecuteCustomFunctionTransactionInput!) {
    executeCustomFunctionTransaction(input: $input) {
      ok
    }
  }
`

export const EXEC_CUSTOM_FUNCTION_PUBLIC_MUTATION = gql`
  mutation EXEC_CUSTOM_FUNCTION_PUBLIC_MUTATION($input: ExecuteCustomFunctionTransactionInput!, $domain: String!) {
    executeCustomFunctionTransactionPublic(input: $input, domain: $domain) {
      ok
    }
  }
`

export const REQUEST_AI_ASSISTANCE_MUTATION = gql`
  mutation REQUEST_AI_ASSISTANCE_MUTATION($input: AiAssistInput!) {
    requestAiAssistance(input: $input) {
      templateId
      fieldLinkId
      suggestions {
        matchedFilter {
          id
          name
        }
        existingRecordId
        fields {
          fieldId
          value
        }
      }
    }
  }
`

export const GENERATE_AI_RISK_ASSESSMENT_MUTATION = gql`
  mutation GENERATE_AI_RISK_ASSESSMENT_MUTATION($input: AiRiskAssessmentInput!) {
    generateAiRiskAssessment(input: $input) {
      fieldId
      value
      explanation
    }
  }
`

export const REQUEST_AI_FIELD_FILL_MUTATION = gql`
  mutation REQUEST_AI_FIELD_FILL_MUTATION($input: AiFieldFillInput!) {
    requestAiFieldFill(input: $input) {
      fieldId
      value
      explanation
    }
  }
`
